module.exports = __webpack_public_path__ + "static/06-usertesting@2x-98e2a9298ef2c5193efdb5c9276609a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/homepage/06-usertesting@2x.jpg
// module id = 2647
// module chunks = 35783957827783